/* MHP coupon popup: no network requests; stores only the last display timestamp. */
(() => {
  if (customElements.get('mhp-gutschein-popup')) return;
  const key = 'mhp:gutschein-popup:last-shown:v1';
  let memoryLastShown = 0;
  class MhpGutscheinPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.editor = Boolean(window.Shopify && window.Shopify.designMode);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.mhp-popup__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.querySelector('.mhp-popup__copy').addEventListener('click', () => this.copyCode(), options);
      this.querySelector('input').addEventListener('click', (event) => event.target.select(), options);
      document.addEventListener('shopify:section:select', (event) => {
        if (this.editor && event.detail.sectionId === this.dataset.sectionId) this.open(true);
      }, options);
      document.addEventListener('shopify:section:deselect', (event) => {
        if (this.editor && event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
      }, options);
      window.addEventListener('storage', (event) => {
        if (event.key === key && !this.editor && !this.eligible()) {
          clearTimeout(this.timer);
          this.dialog.close();
        }
      }, options);
      if (this.editor) {
        if (this.dataset.preview === 'true') this.open(true);
        return;
      }
      if (this.dataset.enabled !== 'true' || this.dataset.hasCode !== 'true' || !this.eligible()) return;
      this.timer = setTimeout(() => this.open(false), Number(this.dataset.delay) * 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
    lastShown() {
      let last = memoryLastShown;
      for (const store of ['localStorage', 'sessionStorage']) {
        try {
          const value = Number(window[store].getItem(key));
          if (Number.isFinite(value) && value > 0 && value <= Date.now()) last = Math.max(last, value);
        } catch (_) { /* Storage can be blocked in private browsers. */ }
      }
      return last;
    }
    eligible() {
      return Date.now() - this.lastShown() >= Number(this.dataset.days) * 86400000;
    }
    remember() {
      memoryLastShown = Date.now();
      for (const store of ['localStorage', 'sessionStorage']) {
        try { window[store].setItem(key, String(memoryLastShown)); } catch (_) { /* In-memory fallback. */ }
      }
    }
    blocked() {
      // Let the existing consent dialog and shopping interactions finish first.
      return document.hidden || window.Cookiebot?.isDialogVisible ||
        document.querySelector('dialog[open], cart-drawer.active, cart-notification.active, details[open] > .search-modal, details[open] > .menu-drawer, modal-dialog[open]');
    }
    open(preview) {
      if (!this.isConnected || this.dialog.open) return;
      clearTimeout(this.timer);
      if (!preview) {
        if (!this.eligible()) return;
        if (this.blocked()) {
          this.timer = setTimeout(() => this.open(false), 1000);
          return;
        }
      }
      this.dialog.showModal();
      if (!preview) this.remember();
    }
    async copyCode() {
      const input = this.querySelector('input');
      const status = this.querySelector('.mhp-popup__status');
      if (!input.value) return;
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(input.value);
          copied = true;
        }
      } catch (_) { /* Clipboard can be restricted in preview iframes. */ }
      if (!copied) {
        input.focus();
        input.select();
        input.setSelectionRange(0, input.value.length);
        try { copied = document.execCommand('copy'); } catch (_) { /* Manual selection remains available. */ }
      }
      status.textContent = copied ? 'Kopiert! Im Checkout einfügen. 🌿' : 'Bitte den markierten Code manuell kopieren.';
    }
  }
  customElements.define('mhp-gutschein-popup', MhpGutscheinPopup);
})();
